import BaseBoxView from "./BaseBoxView";
import GameElementSkinFactory from "./GameElementSkinFactory";
import ItemSlotView from "./ItemSlotView";
import SlotEvent from "./SlotEvent";

export default class GoalBoxView extends BaseBoxView {
    
    /**
     * @param {createjs.DisplayObject} target 
     * @param {GameElementSkinFactory} elementFactory 
     */
    constructor(target, elementFactory) {
        super(target, elementFactory);
        this._enabled = true;
    }

    setSize(n) {
        super.setSize(n);
        this._collectionView.addEventListener(SlotEvent.SELECTED, this._handleSlotSelected.bind(this));
    }

    fillSlot(index, item) {
        this._collectionView.fillSlot(index, item);
    }

    clearSlot(index) {
        this._collectionView.fillSlot(index, null);
    }

    _handleSlotSelected(e) {
        this.dispatchEvent(e.type, e.data);
    }

    /**@type {ItemSlotView} */
    get selectedSlot() {
        return this._collectionView.selectedSlot;
    }

    unselect() {
        this._collectionView.unselect();
    }
}